/**
 * NextAuth reports a rejected sign-in as a code ("CredentialsSignin"), not a sentence. Our own sign-in has already
 * checked the password or OTP with the backend by then, so a code here means the session could not be started.
 */
const MESSAGES: Record<string, string> = {
  CredentialsSignin: 'We could not start your session. Please try signing in again.',
  SessionRequired: 'Please sign in to continue.',
  AccessDenied: 'You do not have access to this account.',
  Configuration: 'Sign-in is temporarily unavailable. Please try again in a moment.',
  Callback: 'Sign-in could not be completed. Please try again.',
};

export function signInErrorMessage(code?: string | null): string {
  if (!code) return 'Sign-in failed. Please try again.';
  if (MESSAGES[code]) return MESSAGES[code];
  // Anything else that already reads like a sentence (it has spaces) is shown as it is.
  return /\s/.test(code) ? code : 'Sign-in failed. Please try again.';
}
